// Redirect /cart to /#cart to support the custom CBI cart drawer
if (window.location.pathname === '/cart') {
  // Redirect /cart to /#cart immediately
  window.location.replace('/#cart');
}

// Function to handle cart hash detection and opening
function handleCartHash() {
  if (window.location.hash === "#cart") {
    // Check if CBI cart is enabled, otherwise use Bloom
    if (window.CBI_CART_PANEL_ENABLED !== false) {
      // Use the existing showCBICart function from cbi_cart.js
      if (typeof showCBICart === "function") {
        showCBICart();
      }
    } else {
      // Fall back to Bloom cart if CBI cart is disabled
      if (window.bloom && typeof bloom.showCart === "function") {
        bloom.showCart();
      }
    }
  }
}

// Check for cart hash on page load
document.addEventListener("DOMContentLoaded", function () {
  handleCartHash();
});

// Listen for hash changes (when user navigates to /#cart)
window.addEventListener("hashchange", function () {
  handleCartHash();
});

// Intercept all fetch calls to /cart/add and block unauthorized ones
(function() {
  const originalFetch = window.fetch;
  window.CBI_ALLOWED_ADD_TO_CART = false;
  
  window.fetch = function(...args) {
    const url = args[0];
    const urlString = typeof url === 'string' ? url : url.url;
    
    // Check if this is a cart add request
    if (urlString && (urlString.includes('/cart/add.js') || urlString.includes('/cart/add'))) {
      // Only allow if our custom handler set the flag
      if (!window.CBI_ALLOWED_ADD_TO_CART) {
        // Return a fake successful response to prevent errors
        return Promise.resolve(new Response(JSON.stringify({ok: true}), {
          status: 200,
          headers: {'Content-Type': 'application/json'}
        }));
      }
      
      // Reset flag after allowing
      window.CBI_ALLOWED_ADD_TO_CART = false;
    }
    
    return originalFetch.apply(this, args);
  };
})();

// constants
const SCROLL_Y_KEY = "scrollY";

const cbi_cart_toggle = document.querySelector(window.CBI_CART_ICON_SELECTOR || "[data-testid='cart-icon']");
const cbi_cart_toggle_mobile = document.querySelector(window.CBI_CART_ICON_MOBILE_SELECTOR || "#cartToggleMob");

// Store the element that opened the cart for focus restoration
let cartTriggerElement = null;

// Flag to prevent interceptor from catching internal cart operations
let isInternalCartOperation = false;

// Counter to track pending cart operations in queue
let queuedOperationsCount = 0;

// Cart mutation queue to prevent 409 conflicts from parallel requests
const cartMutationQueue = {
  queue: Promise.resolve(),
  enqueue(operation) {
    // Increment counter and disable checkout button
    queuedOperationsCount++;
    const checkoutBtn = document.getElementById('checkout-button');
    if (checkoutBtn) {
      checkoutBtn.disabled = true;
    }
    
    this.queue = this.queue
      .then(operation)
      .catch(err => {
        console.error('[Cart Queue] Operation failed:', err);
        // Don't break the queue chain - continue processing
        return Promise.resolve();
      })
      .finally(() => {
        // Decrement counter
        queuedOperationsCount--;
        
        // Only re-enable button when ALL operations complete
        if (queuedOperationsCount === 0) {
          // Get fresh reference to button (DOM may have been replaced by fetchSection)
          const checkoutBtn = document.getElementById('checkout-button');
          if (checkoutBtn) {
            checkoutBtn.disabled = false;
            checkoutBtn.removeAttribute('disabled');
          }
          // Now let checkMinimumBottles() set the correct state based on bottle count
          checkMinimumBottles();
        }
      });
    return this.queue;
  }
};

// Utility function to clean up theme scroll locks (theme-agnostic)
const cleanupThemeScrollLocks = () => {
  const commonScrollLockClasses = [
    'no-scroll', 'no-overflow', 'lock-scroll', 'scroll-lock', 
    'is-locked', 'overflow-hidden', 'modal-open', 'drawer-open'
  ];
  
  commonScrollLockClasses.forEach(cls => {
    document.documentElement.classList.remove(cls);
    document.body.classList.remove(cls);
  });
  
  // Reset common inline style patterns used for scroll locking
  if (document.documentElement.style.overflow === 'hidden') {
    document.documentElement.style.overflow = '';
  }
  if (document.body.style.overflow === 'hidden') {
    document.body.style.overflow = '';
  }
  if (document.body.style.position === 'fixed') {
    document.body.style.position = '';
    document.body.style.width = '';
  }
};

const hideCBICart = () => {
  const cbi_cart_overlay = document.querySelector(".cbi-cart_overlay");
  const cbi_cart_shell = document.querySelector(".cbi-cart_shell");
  
  cbi_cart_overlay.style.opacity = "0";
  cbi_cart_shell.style.transform = "translateX(100%)";
  
  // Unlock body scroll - remove CBI cart's class
  document.body.classList.remove('cbi-cart-open');

  document.body.style.top = '';
  const scrollY = sessionStorage.getItem(SCROLL_Y_KEY);
  window.scrollTo({
    top: parseInt(scrollY, 10), 
    left: 0,
    behavior: 'instant' // instant scroll back to previous position
  });
  
  // Clean up any theme-specific scroll locks that may have been added
  cleanupThemeScrollLocks();
  
  // Set aria-hidden to true when cart is closed
  cbi_cart_shell.setAttribute('aria-hidden', 'true');

  setTimeout(() => {
    cbi_cart_overlay.style.display = "none";
    
    // Return focus to the element that opened the cart
    if (cartTriggerElement) {
      cartTriggerElement.focus();
      cartTriggerElement = null;
    }
  }, 900); // Slightly faster than the transition, helps it feel "snappy"
};

const showCBICart = () => {
  // Clean up any stale scroll locks before opening (prevents conflicts)
  cleanupThemeScrollLocks();
  
  // Show the CBI cart overlay and slide in the cart shell
  const cbi_cart_overlay = document.querySelector(".cbi-cart_overlay");
  const cbi_cart_shell = document.querySelector(".cbi-cart_shell");
  const trash_icons = document.querySelectorAll(".trash-icon svg");

  // Lock body scroll
  document.body.classList.add('cbi-cart-open');
  const scrollY = sessionStorage.getItem(SCROLL_Y_KEY);
  document.body.style.top = `-${scrollY}px`;

  // Initialize progress bar immediately without transition to prevent flash
  initializeProgressBarState();

  // Enable animation before showing
  cbi_cart_shell.classList.add("animate-ready");

  cbi_cart_overlay.style.opacity = "1";
  cbi_cart_overlay.style.display = "block";
  cbi_cart_shell.style.transform = "translateX(0px)";
  trash_icons.forEach((svg) => {
    svg.style.visibility = "visible";
  });

  // Add event listener to close button
  const closeButton = document.querySelector(".cbi-cart_close-button");
  if (closeButton && !closeButton.hasAttribute("data-event-listener-added")) {
    closeButton.setAttribute("data-event-listener-added", "true");
    closeButton.addEventListener("click", function (_e) {
      hideCBICart();
    });
  }

  // Add event listener to close cart when clicking outside of it
  const cartOverlay = document.querySelector(".cbi-cart_overlay");
  if (cartOverlay && !cartOverlay.hasAttribute("data-event-listener-added")) {
    cartOverlay.setAttribute("data-event-listener-added", "true");
    cartOverlay.addEventListener("click", function (_e) {
      hideCBICart();
    });
  }

  // Ensure checkout button event listener is attached
  setupCheckoutButtonEventListener();

  // Check minimum bottles requirement and update button state immediately
  setTimeout(() => {
    checkMinimumBottles();
  }, 50);
  
  // Set aria-hidden to false when cart is open
  cbi_cart_shell.setAttribute('aria-hidden', 'false');
  
  // Focus the close button
  setTimeout(() => {
    const closeButton = document.querySelector('.cbi-cart_close-button');
    if (closeButton) closeButton.focus();
  }, 100);
};

// Function to initialize progress bar state immediately
const initializeProgressBarState = () => {
  const progressBar = document.getElementById('carrot-progress');
  if (!progressBar) return;

  // Add no-transition class to prevent flash
  progressBar.classList.add('no-transition');

  // Get current cart and calculate bottles
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let bottles = 0;
      cart.items.forEach(item => {
        const qty = parseInt(item.properties?.bottle_qty) || 1;
        bottles += qty * item.quantity;
      });

      // Try to get min bottles from multiple sources
      let minBottles = 1; // default fallback

      // First try OrderSummaryConfig
      if (window.OrderSummaryConfig?.minBottles) {
        minBottles = window.OrderSummaryConfig.minBottles;
      } 
      // Fallback: try to get from DOM script tag containing minBottles
      else {
        const scriptTags = document.querySelectorAll('script');
        for (let script of scriptTags) {
          if (script.textContent && script.textContent.includes('minBottles')) {
            const match = script.textContent.match(/const minBottles = (\d+);/);
            if (match) {
              minBottles = parseInt(match[1], 10);
              break;
            }
          }
        }
      }

      const progress = Math.max((bottles / minBottles) * 100, 3);

      // Set initial width without animation
      progressBar.style.width = Math.min(progress, 100) + '%';
      progressBar.classList.toggle('shipping-progress_carrot-progress-complete', bottles >= minBottles);

      // Remove no-transition class after setting initial state
      setTimeout(() => {
        progressBar.classList.remove('no-transition');
      }, 10);
    })
    .catch(() => {
      // Fallback: set to minimum width
      progressBar.style.width = '3%';
      setTimeout(() => {
        progressBar.classList.remove('no-transition');
      }, 10);
    });
};

if (cbi_cart_toggle)  {
  cbi_cart_toggle.addEventListener("click", function (e) {
    e.preventDefault();
    cartTriggerElement = document.activeElement;
    showCBICart();
  });
}

if (cbi_cart_toggle_mobile)  {
  cbi_cart_toggle_mobile.addEventListener("click", function (e) {
    e.preventDefault();
    cartTriggerElement = document.activeElement;
    showCBICart();
  });
}

// Simple focus trap - just handle Escape key and Tab cycling within cart
document.addEventListener('keydown', function(e) {
  const cartShell = document.querySelector('.cbi-cart_shell');
  if (!cartShell || cartShell.getAttribute('aria-hidden') === 'true') return;
  
  // Escape closes cart
  if (e.key === 'Escape') {
    hideCBICart();
    return;
  }
  
  // Tab cycles within cart
  if (e.key === 'Tab') {
    const focusable = cartShell.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    const firstFocusable = focusable[0];
    const lastFocusable = focusable[focusable.length - 1];
    
    if (e.shiftKey && document.activeElement === firstFocusable) {
      lastFocusable.focus();
      e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === lastFocusable) {
      firstFocusable.focus();
      e.preventDefault();
    }
  }
});

// Add checkout button event listener that respects disabled state
document.addEventListener("DOMContentLoaded", function () {
  setupCheckoutButtonEventListener();
});

// Function to setup checkout button event listener
function setupCheckoutButtonEventListener() {
  const checkoutButton = document.getElementById("checkout-button");
  if (
    checkoutButton &&
    !checkoutButton.hasAttribute("data-event-listener-added")
  ) {
    // Mark that we've added the event listener to avoid duplicates
    checkoutButton.setAttribute("data-event-listener-added", "true");

    checkoutButton.addEventListener("click", function (e) {
      // Prevent default action
      e.preventDefault();
      e.stopPropagation();

      // Defensive check: prevent navigation if operations are still queued
      if (queuedOperationsCount > 0) {
        console.log('[Checkout] Blocked: ' + queuedOperationsCount + ' operations still pending');
        return false;
      }

      // Check if button is disabled
      if (this.disabled || this.classList.contains("disabled")) {
        // Show the minimum bottles message if it's not already showing
        const messageElement = document.getElementById(
          "minimum-bottles-message"
        );
        if (messageElement) {
          messageElement.style.display = "block";
          // Flash the message to draw attention
          messageElement.style.animation = "flashMessage 1s ease-in-out";
        }

        return false;
      }

      // Button is enabled, proceed to checkout
      window.location.href = "/checkout";
    });
  }
}

function findSpecificElement(item, targetId) {
  const elem = item.parentNode.querySelector(`#${targetId}`);
  if (elem) return elem;
  return null;
}

function disableButton(item) {
  item.setAttribute("disabled", "");
  item.style.opacity = "0.5";
  item.style.cursor = "default";
}

function enableButton(item) {
  item.removeAttribute("disabled");
  item.style.opacity = "1";
  item.style.cursor = "pointer";
}

function showMinLimit(item) {
  const minLimit = findSpecificElement(item, "limit-message-container-min");
  if (minLimit) {
    minLimit.removeAttribute("hidden");
  }
}

function hideMinLimit(item) {
  const minLimit = findSpecificElement(item, "limit-message-container-min");
  if (minLimit) {
    minLimit.setAttribute("hidden", "");
  }
}

function showMaxLimit(item) {
  const maxLimit = findSpecificElement(item, "limit-message-container-max");
  if (maxLimit) {
    maxLimit.removeAttribute("hidden");
  }
}

function hideMaxLimit(item) {
  const maxLimit = findSpecificElement(item, "limit-message-container-max");
  if (maxLimit) {
    maxLimit.setAttribute("hidden", "");
  }
}

function checkMinimumBottles() {
  const minBottlesElement = document.querySelector(
    "#minimum-bottles-message #cart-minimum-bottles-qty"
  );
  if (minBottlesElement) {
    const min_bottles = minBottlesElement
      ? parseInt(minBottlesElement.textContent, 10)
      : 1;
    // Count the total of items that are not alcoholic beverages
    const nonAlcoholicItems = document.querySelectorAll(
      "[data-category='non-alcoholic']"
    );
    // Count the total number of bottles in the cart
    const productDetails = document.querySelectorAll(
      "[data-category='alcoholic-beverage']"
    );
    // Hide the message if there are no items in the cart
    if (productDetails.length === 0 && nonAlcoholicItems.length === 0) {
      const messageElement = document.getElementById("minimum-bottles-message");
      if (messageElement) {
        messageElement.style.display = "none";
      }
      return;
    }
    // Enable checkout if there are only non-alcoholic items in the cart
    if (nonAlcoholicItems.length > 0 && productDetails.length === 0) {
      const messageElement = document.getElementById("minimum-bottles-message");
      if (messageElement) {
        messageElement.style.display = "none";
      }
      const checkoutButton = document.getElementById("checkout-button");
      if (checkoutButton) {
        checkoutButton.disabled = false;
        checkoutButton.removeAttribute("disabled");
        checkoutButton.classList.remove("disabled");
        checkoutButton.classList.add("checkout-button");
      }
      return;
    }
    // Count the total number of bottles per item (regex-based fallback for subscription items)
    let totalBottles = 0;
    productDetails.forEach((product) => {
      const description = product.querySelector('.description span');
      // Support both regular items (with an input) and subscription items (may lack an editable input)
      let currentValue = 1;
      const qtyInput = product.querySelector('input[type=text]');
      if (qtyInput) {
        currentValue = parseInt(qtyInput.value, 10);
      } else {
        // Parse a number preceding the word "bottle" within the product text (e.g. "3 Bottles", "6 bottles every 2 months")
        const match = product.textContent.match(/(\d+)\s+bottles?/i);
        if (match) {
          currentValue = parseInt(match[1], 10);
        }
      }
      let bottleCount = 0;
      if (description) {
        bottleCount = parseInt(description.textContent, 10) * currentValue;
      } else {
        bottleCount = currentValue;
      }
      totalBottles += bottleCount;
    });
    // Check if the total number of bottles is less than the minimum required
    if (totalBottles < min_bottles) {
      const messageElement = document.getElementById("minimum-bottles-message");
      if (messageElement) {
        messageElement.style.display = "block";
        // Ensure message is visible immediately
        messageElement.style.opacity = "1";
        messageElement.style.visibility = "visible";
      }
      const checkoutButton = document.getElementById("checkout-button");
      if (checkoutButton) {
        checkoutButton.disabled = true;
        checkoutButton.setAttribute("disabled", "disabled");
        checkoutButton.classList.remove("checkout-button");
        checkoutButton.classList.add("disabled");
      }
    } else {
      const messageElement = document.getElementById("minimum-bottles-message");
      if (messageElement) {
        messageElement.style.display = "none";
      }
      const checkoutButton = document.getElementById("checkout-button");
      if (checkoutButton) {
        checkoutButton.disabled = false;
        checkoutButton.removeAttribute("disabled");
        checkoutButton.classList.remove("disabled");
        checkoutButton.classList.add("checkout-button");
      }
    }
  }
}

// Debounce function to avoid too many rapid calls
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Debounced version of checkMinimumBottles
const debouncedCheckMinimumBottles = debounce(checkMinimumBottles, 100);

function validateBoundaries(
  item,
  productKey,
  min = 1,
  max = 500,
  isMinDisplayed = true
) {
  const currentValue = parseInt(
    item.parentNode.querySelectorAll("input[type=text]")[0].value
  );
  if (currentValue <= min) {
    hideMaxLimit(item.parentNode.parentNode);
    if (isMinDisplayed && min > 1) showMinLimit(item.parentNode.parentNode);
    disableButton(item.parentNode.querySelectorAll("button")[0]);
    enableButton(item.parentNode.querySelectorAll("button")[1]);
    item.parentNode.querySelectorAll("input[type=text]")[0].value =
      min.toString();
    updateItemQuantityInCart(min, productKey);
  } else if (currentValue >= max) {
    hideMinLimit(item.parentNode.parentNode);
    showMaxLimit(item.parentNode.parentNode);
    disableButton(item.parentNode.querySelectorAll("button")[1]);
    enableButton(item.parentNode.querySelectorAll("button")[0]);
    item.parentNode.querySelectorAll("input[type=text]")[0].value =
      max.toString();
    updateItemQuantityInCart(max, productKey);
  } else {
    enableButton(item.parentNode.querySelectorAll("button")[0]);
    enableButton(item.parentNode.querySelectorAll("button")[1]);
    hideMinLimit(item.parentNode.parentNode);
    hideMaxLimit(item.parentNode.parentNode);
    updateItemQuantityInCart(currentValue, productKey);
  }
}

function decrementQuantity(item, productKey, step = 1, min = 1) {
  const currentValue = parseInt(
    item.parentNode.querySelectorAll("input[type=text]")[0].value
  );
  hideMaxLimit(item.parentNode.parentNode);
  if (currentValue >= min) {
    let newValue = currentValue - step;
    if (newValue <= min) {
      newValue = min;
      disableButton(item);
      enableButton(item.parentNode.querySelectorAll("button")[1]);
      if (min > 1) showMinLimit(item.parentNode.parentNode);
      item.parentNode.querySelectorAll("input[type=text]")[0].value =
        min.toString();
    } else {
      hideMinLimit(item.parentNode.parentNode);
      enableButton(item.parentNode.querySelectorAll("button")[1]);
      item.parentNode.querySelectorAll("input[type=text]")[0].value =
        newValue.toString();
    }
    updateItemQuantityInCart(newValue, productKey);
  }
}

function incrementQuantity(item, productKey, step = 1, max = 500) {
  const currentValue = parseInt(
    item.parentNode.querySelectorAll("input[type=text]")[0].value
  );
  hideMinLimit(item.parentNode.parentNode);
  if (currentValue <= max) {
    let newValue = currentValue + step;
    if (newValue >= max) {
      newValue = max;
      disableButton(item);
      enableButton(item.parentNode.querySelectorAll("button")[0]);
      showMaxLimit(item.parentNode.parentNode);
      item.parentNode.querySelectorAll("input[type=text]")[0].value =
        max.toString();
    } else {
      hideMaxLimit(item.parentNode.parentNode);
      enableButton(item.parentNode.querySelectorAll("button")[0]);
      item.parentNode.querySelectorAll("input[type=text]")[0].value =
        newValue.toString();
    }
    updateItemQuantityInCart(newValue, productKey);
  }
}

function updateItemQuantity(quantity, productKey) {
  const cart_product_item = document.getElementById(productKey);
  if (cart_product_item) {
    cart_product_item.querySelectorAll("input[type=text]")[0].value =
      quantity.toString();
  }
}

function fetchSection(sectionId) {
  return fetch(window.Shopify.routes.root + "?sections=" + sectionId, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      const parser = new DOMParser();
      const newSection = parser.parseFromString(data["cbi-cart"], "text/html");
      const CBICartWrapper = newSection.getElementById("cbi-cart_wrapper");
      const currentCartWrapper = document.getElementById("cbi-cart_wrapper");
      if (CBICartWrapper && currentCartWrapper) {
        // Ensure new cart shell starts without animation enabled
        const newCartShell = CBICartWrapper.querySelector(".cbi-cart_shell");
        if (newCartShell) {
          newCartShell.classList.remove("animate-ready");
        }

        currentCartWrapper.remove();
        document
          .getElementById("shopify-section-cbi-cart")
          .appendChild(CBICartWrapper);
      }
    });
}
function displayErrorInCollectionPage(formData, data) {
  const pdpCardsErrors = document.querySelectorAll(".product-card-error");
  pdpCardsErrors.forEach((elem) => elem.remove());
  if (!formData || !data || !data.message) return;
  let fd;
  try {
    fd = JSON.parse(formData);
  } catch (e) {
    console.error("Invalid JSON in formData:", formData);
    return;
  }
  const variantId = fd?.items?.[0]?.id;
  if (!variantId) return;

  const container = document.querySelector(
    `.prod_card[data-productvarient="${variantId}"]`
  );
  if (!container) return;

  const btnWrapper = container.querySelector(".product-card-btn-container");
  if (!btnWrapper) return;

  const errorDiv = document.createElement("div");
  errorDiv.className = "product-card-error";
  errorDiv.textContent = data.message;
  errorDiv.style.fontSize = "12px";
  errorDiv.style.color = "red";
  btnWrapper.prepend(errorDiv);
}

// Wrapper function to allow for a custom add to cart function via theme settings
const originaladdToCartFunctionName = window.CBI_CART_ADD_TO_CART_FUNCTION;

if (originaladdToCartFunctionName !== "" && typeof window[originaladdToCartFunctionName] === 'function') {
  window[originaladdToCartFunctionName] = function handleCBIaddToCBICart(variantId, quantity) {
    if (typeof addToCBICart === 'function') {
      const itemToAdd = {
        items: [
          {
            id: variantId.toString(),
            quantity: quantity || 1
          }
        ]
      };
      addToCBICart(JSON.stringify(itemToAdd));
    } else {
      console.error('addToCBICart function not found');
    }
  }
}

function getQuantityToAdd(element) {
  let parentContainer = element.parentElement.parentElement.parentElement // TODO: make this non-boco specific
  let inputElement = parentContainer.querySelector("input")

  return inputElement.value
}

function addToCBICart(formData, isJson = true) {
  window.CBI_ALLOWED_ADD_TO_CART = true;
  // storing so once page refreshes we can be taken back to the previous position
  sessionStorage.setItem(SCROLL_Y_KEY, window.scrollY);
  
  // Queue this cart mutation to prevent 409 conflicts
  return cartMutationQueue.enqueue(() => {
    isInternalCartOperation = true;
    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
          "Content-Type": "application/json"
        },
      body: formData
    })
      .then((response) => response.json())
      .then(async (data) => {
        console.log("[Cart Add] Response from Shopify:", data);
        if (data.status == 422) {
          /* Display cart errors if they are present. */
          displayError(data.message);
          // Display error in pdp page
          // TODO:Do I need to update this id?
          if (document.getElementById("pdp-cart-error")) {
            document.getElementById("pdp-cart-error").innerText = data.message;
          }
          // display erros pdp-card collection page
          displayErrorInCollectionPage(formData, data);
        } else {
          // @TODO REMOVE ONCE BLOOM IS DECOUPLED
          if (window.CBI_CART_PANEL_ENABLED === false) {
            return bloomFetchCart();
          }
          displayErrorInCollectionPage([], []);
          
          // Return the Promise chain to ensure queue waits for all async work
          return fetchSection("cbi-cart").then(() => {
            return new Promise(resolve => {
              setTimeout(() => {
                showCBICart();
                checkMinimumBottles();
                document.dispatchEvent(new Event("cart:add"));
                document.dispatchEvent(new Event("cart:updated"));
                if (data.status == 422) {
                  displayError(data.message);
                } else {
                  // Use line item key (unique per cart line) to avoid conflating subscription & one-time entries
                  document.dispatchEvent(
                    new CustomEvent("cart:checkLimits", {
                      detail: {
                        itemId: data.key || data.id,
                      },
                    })
                  );
                }
                resolve();
              }, 50); // small delay to ensure cart section has rendered before events fire
            });
          });
        }
      })
    .catch(function (error) {
      console.error("[Cart Add] Error:", error);
      displayError(error.message);
    })
      .finally(() => {
        isInternalCartOperation = false;
      });
  });
}

function updateItemQuantityInCart(quantity, lineItemKey) {
  // Treat the provided identifier as the line item key (generated by Shopify per cart line)
  const itemUpdate = { id: lineItemKey.toString(), quantity };
  console.log('[Cart Update] Sending to Shopify:', itemUpdate);
  
  // Queue this cart mutation to prevent 409 conflicts
  return cartMutationQueue.enqueue(() => {
    isInternalCartOperation = true;
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(itemUpdate)
    })
      .then(r => r.json())
      .then(data => {
        console.log('[Cart Update] Response from Shopify:', data);
        if (data.status == 422) {
          displayError(data.message);
          document.dispatchEvent(new CustomEvent('cart:checkItemInventory', { detail: { itemId: lineItemKey } }));
          return;
        }
        if (data.item_count === 0) updateCartCounter(0);
        const existingError = document.querySelector('#cart-error');
        if (existingError) existingError.remove();
        if (quantity === 0) removeItemFromCart(lineItemKey);
        checkMinimumBottles();
        document.dispatchEvent(new Event('cart:updated'));
      })
      .catch(err => {
        console.error('[Cart Update] Error:', err);
        displayError(err.message);
      })
      .finally(() => {
        isInternalCartOperation = false;
      });
  });
}

function removeItemFromCart(productKey) {
  let totalValue = document.getElementById(productKey);
  if (totalValue) {
    totalValue.remove();
  }
}

function decrementValueOnItem(item, step = 1) {
  if (
    parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) >
    step
  ) {
    item.parentNode.querySelectorAll("input[type=text]")[0].value = (
      parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) -
      step
    ).toString();
  }
}

function incrementValueOnItem(item, step = 1) {
  item.parentNode.querySelectorAll("input[type=text]")[0].value = (
    parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) +
    step
  ).toString();
}

function updateCartCounter(quantity) {
  // todo: make cart selector customizable via theme settings
  const cartCounterBubbleSelector = window.CBI_CART_COUNT_BUBBLE_SELECTOR || "#cart-counter";
  const cartCounterBubbleSelectorMobile = window.CBI_CART_COUNT_BUBBLE_MOBILE_SELECTOR || "#cart-counter-mob";
  
  // Horizon only
  const horizonCartElement = document.querySelector('div[ref="cartBubble"]');
  const horizonCartParent = document.querySelector('cart-icon');

  const cartCounter = document.querySelector(cartCounterBubbleSelector);
  const cartCounterMobile = document.querySelector(cartCounterBubbleSelectorMobile);

  // Early return only if NEITHER element exists
  if (!cartCounter && !cartCounterMobile) {
    console.warn('No cart counter elements found');
    return;
  }

  // Update desktop counter if it exists
  if (cartCounter) {
    if (quantity > 0) {
      cartCounter.classList.remove("hidden");
      cartCounter.classList.add("flex");
      horizonCartElement?.classList.remove("visually-hidden");
      horizonCartParent?.classList.add("header-actions__cart-icon--has-cart");
      console.log(`updating cart quantity to ${quantity}`)
    } else {
      cartCounter.classList.add("hidden");
      horizonCartElement?.classList.add("visually-hidden");
      horizonCartParent?.classList.remove("header-actions__cart-icon--has-cart");
    }
    cartCounter.textContent = quantity;
  }

  // Update mobile counter if it exists
  if (cartCounterMobile) {
    if (quantity > 0) {
      cartCounterMobile.classList.remove("hidden");
      cartCounterMobile.classList.add("flex");
      horizonCartElement?.classList.remove("visually-hidden");
      horizonCartParent?.classList.add("header-actions__cart-icon--has-cart");
    } else {
      cartCounterMobile.classList.add("hidden");
      horizonCartElement?.classList.add("visually-hidden");
      horizonCartParent?.classList.remove("header-actions__cart-icon--has-cart");
    }
    cartCounterMobile.textContent = quantity;
  }
}

function displayError(errorMessage) {
  var errorTag = document.createElement("div");
  errorTag.id = "cart-error";
  errorTag.classList.add("cart-error-message");
  errorTag.classList.add("mt-2");
  errorTag.style.fontSize = "12px";
  errorTag.style.fontWeight = "600";
  errorTag.style.color = "#DC1212";

  // Create a close button
  const closeButton = document.createElement("span");
  closeButton.classList.add("close-button");
  closeButton.innerText = "X";

  // Add click event to remove the error div
  closeButton.addEventListener("click", () => {
    errorTag.remove();
  });

  // Append the close button to the error tag
  errorTag.innerText = errorMessage;
  errorTag.appendChild(closeButton);
  if (document.querySelector("#cart-error")) {
    document.querySelector("#cart-error").remove();
  }
  var eElement = document.querySelector("#product-list-container");
  if (eElement) {
    const firstCartItem = eElement.querySelector(".cart-product-item");
    if (firstCartItem) {
      eElement.insertBefore(errorTag, firstCartItem);
    } else {
      eElement.appendChild(errorTag);
    }
  } else {
    console.error("Cart Error:", errorMessage);
  }
}

document.addEventListener('cart:checkLimits', (event) => {
  const key = event.detail?.itemId?.toString();
  if (!key) return;
  const minEl = document.getElementById('min-purchase-' + key);
  const maxEl = document.getElementById('max-purchase-' + key);
  const minVal = minEl ? parseInt(minEl.innerText, 10) : 1;
  const maxVal = maxEl ? parseInt(maxEl.innerText, 10) : 500;
  const wrapper = document.getElementById(key);
  if (!wrapper) return; // element may not yet exist after async section swap
  const qtyInputs = wrapper.querySelectorAll('input[type=text]');
  if (!qtyInputs.length) return; // subscription line (no editable qty)
  const input = qtyInputs[0];
  const current = parseInt(input.value, 10);
  if (current <= minVal || current >= maxVal) {
    validateBoundaries(input, key, minVal, maxVal, minVal > 1);
  }
});

document.addEventListener('cart:checkLimits', async () => {
  try {
    const resp = await fetch('/cart.js');
    if (!resp.ok) throw new Error('Failed to fetch cart data');
    const cart = await resp.json();
    cart.items.forEach(item => {
      const key = item.key; // unique line item key
      const wrapper = document.getElementById(key);
      if (!wrapper) return;
      const qtyInputs = wrapper.querySelectorAll('input[type=text]');
      if (!qtyInputs.length) return; // skip subscription line
      const input = qtyInputs[0];
      const current = parseInt(input.value, 10);
      if (item.quantity !== current) updateItemQuantityInCart(current, key);
    });
  } catch (e) {
    console.error('Error fetching cart:', e);
  }
});

document.addEventListener('cart:checkItemInventory', async (event) => {
  try {
    const key = event.detail?.itemId?.toString();
    if (!key) return;
    const resp = await fetch('/cart.js');
    if (!resp.ok) throw new Error('Failed to fetch cart data');
    const cart = await resp.json();
    const line = cart.items.find(i => i.key === key);
    if (!line) return;
    const wrapper = document.getElementById(key);
    if (!wrapper) return;
    const qtyInputs = wrapper.querySelectorAll('input[type=text]');
    if (!qtyInputs.length) return; // subscription line – nothing to sync
    const input = qtyInputs[0];
    enableButton(input.parentNode.querySelectorAll('button')[0]);
    enableButton(input.parentNode.querySelectorAll('button')[1]);
    hideMinLimit(input.parentNode.parentNode);
    hideMaxLimit(input.parentNode.parentNode);
    input.value = line.quantity.toString();
  } catch (e) {
    console.error('Error fetching cart:', e);
  }
});

// ---------------------------------------------------------------------------
//
// START Old Bloom Code
// @TODO REMOVE ONCE BLOOM IS DECOUPLED
//
function bloomaddToCBICart(v_id, item) {
  const inputElement = item.parentNode.querySelectorAll("input[type=text]")[0];

  let quantityValue = inputElement?.value;

  if (!inputElement) {
    quantityValue = "1";
  }

  addAndOpenCart(v_id, quantityValue);

  if (item.parentNode.querySelectorAll("input[type=text]")[0].value == "") {
    item.parentNode.querySelectorAll("input[type=text]")[0].value = 1;
  }
}
async function addAndOpenCart(id, quantity, properties) {
  // Add item to Bloom cart
  await bloom
    .shoppingCart()
    .add([{ id: id, quantity: quantity, properties: properties || {} }]);

  // Reload cart data to ensure it's up to date
  await bloom.reloadCart();

  // Dispatch cart updated event
  document.dispatchEvent(new Event("cart:updated"));

  // Show the Bloom cart directly (don't use cartToggle which might trigger CBI cart)
  bloom.showCart();
}

async function bloomFetchCart() {
  try {
    const cart = await window.bloomCart.get();

    if (cart) {
      document.getElementById("cart-counter").textContent = cart.item_count;

      // Reload the Bloom cart UI to make sure it shows the updated items
      await bloom.reloadCart();

      setTimeout(() => {
        document.getElementById("cart-counter").click();
      }, 500);
    } else {
      console.error("cart not found");
    }
  } catch (error) {
    console.error("Error in bloomFetchCart:", error);
  }
}
//
// END Old Bloom Code
//
// ---------------------------------------------------------------------------

// Intercept fetch calls to cart/add.js endpoint (theme-agnostic)
function interceptCartAddFetch() {
  const originalFetch = window.fetch;
  
  window.fetch = function(url, options) {
    const isCartAdd = typeof url === 'string' && url.includes('cart/add.js');
    
    // Only intercept external calls, not our internal calls from addToCBICart
    if (isCartAdd && options?.method === 'POST' && !isInternalCartOperation) {
      
      try {
        let bodyData, variantId, quantity = 1;
        let producData = null;
        
        // Handle JSON format (modern themes)
        const isJson = options.headers?.['Content-Type']?.includes('application/json') ||
                       options.headers?.['content-type']?.includes('application/json');
        
        if (isJson) {
          bodyData = options.body;
          const productDataElement = document.querySelector('[data-product-json]');

          if (productDataElement) {
            productData = JSON.parse(productDataElement.textContent);
          }

          console.log("in interceptCartAddFetch - JSON body data:", bodyData)
          const parsed = JSON.parse(bodyData);
          variantId = productData?.selected_variant_id || parsed.id || parsed.items?.[0]?.id || parsed['product-id'] || parsed;
          quantity = parsed.quantity || parsed.items?.[0]?.quantity || 1;
          // Transform to items array format (just like FormData does on line 879)
          bodyData = JSON.stringify({ items: [{ id: variantId, quantity }] });
        }
        // Handle FormData format (other themes)
        else if (options.body instanceof FormData) {
          const fd = options.body;
          console.log('Intercepted FormData:', fd);
          variantId = fd.get('id') || fd.get('variant_id') || fd.get('product-id');
          quantity = parseInt(fd.get('quantity')) || 1;
          bodyData = JSON.stringify({ items: [{ id: variantId, quantity }] });
        }
        
        if (bodyData) {
          console.log('in interceptCartAddFetch - adding to CBI cart with data:', bodyData);
          addToCBICart(bodyData, true);
          
          // Return mock success response so themes can complete their flow
          return Promise.resolve({
            ok: true,
            status: 200,
            json: () => Promise.resolve({
              id: variantId,
              variant_id: variantId,
              quantity: quantity,
              key: `${variantId}:${Date.now()}`
            })
          });
        }
      } catch (error) {
        console.error('CBI Cart: Interception error', error);
      }
    }
    
    return originalFetch.apply(this, arguments);
  };
}

interceptCartAddFetch();

// Function to handle cart hash detection and opening
function handleCartHash() {
  if (window.location.hash === "#cart") {
    // Check if CBI cart is enabled, otherwise use Bloom
    if (window.CBI_CART_PANEL_ENABLED !== false) {
      // Use the existing showCBICart function from cbi_cart.js
      if (typeof showCBICart === "function") {
        showCBICart();
      }
    } else {
      // Fall back to Bloom cart if CBI cart is disabled
      if (window.bloom && typeof bloom.showCart === "function") {
        bloom.showCart();
      }
    }
  }
}

// Check for cart hash on page load
document.addEventListener("DOMContentLoaded", function () {
  // Initialize progress bar state before showing cart to prevent flash
  if (window.location.hash === "#cart" && typeof initializeProgressBarState === "function") {
    initializeProgressBarState();
  }

  handleCartHash();
});

// Listen for hash changes (when user navigates to /#cart)
window.addEventListener("hashchange", function () {
  handleCartHash();
});